import {
  Action,
  createStore,
  combineReducers,
  applyMiddleware,
  compose,
} from 'redux'
import thunk, { ThunkDispatch, ThunkAction } from 'redux-thunk'

import pagesReducer from './pages/reducer'
import stringsReducer from './strings/reducer'
import headerReducer from './header/reducer'
import footerReducer from './footer/reducer'
import menusReducer from './menus/reducer'
import userReducer from './user/reducer'

export const rootReducer = combineReducers({
  strings: stringsReducer,
  pages: pagesReducer,
  header: headerReducer,
  footer: footerReducer,
  menus: menusReducer,
  user: userReducer,
})

//@ts-expect-error preloaded state on window
const preloadedState = window.__PRELOADED_STATE__
//@ts-expect-error preloaded state on window
delete window.__PRELOADED_STATE__

//@ts-expect-error Redux dev tools not is on window
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  rootReducer,
  preloadedState || {},
  composeEnhancers(applyMiddleware(thunk)),
)

//@ts-expect-error preloaded state on window
window.snapSaveState = store.getState

export type RootThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export type RootDispatch = typeof store.dispatch

export type RootState = ReturnType<typeof rootReducer>

export type RootThunkDispatch = ThunkDispatch<
  RootState,
  unknown,
  Action<string>
>

export default store
